export const typeOfFindPreparationsSimilaritySearchDialog = 'typeOfFindPreparationsSimilaritySearchDialog';

export const REDUCER_KEY_FIND_PREPARATIONS_SIMILARITY_SEARCH = 'findPreparations/similaritySearch';

export const CLEAN_STATE = 'findPreparations/similaritySearch/CLEAN_STATE';

export const SIMILARITY_SEARCH = 'findPreparations/similaritySearch/SIMILARITY_SEARCH';
export const SIMILARITY_SEARCH_SUCCESS = 'findPreparations/similaritySearch/SIMILARITY_SEARCH_SUCCESS';
export const SIMILARITY_SEARCH_FAILURE = 'findPreparations/similaritySearch/SIMILARITY_SEARCH_FAILURE';

export const LOAD_SIMILARITY_SEARCH_RESULTS = 'findPreparations/similaritySearch/LOAD_SIMILARITY_SEARCH_RESULTS';
export const LOAD_SIMILARITY_SEARCH_RESULTS_SUCCESS = 'findPreparations/similaritySearch/LOAD_SIMILARITY_SEARCH_RESULTS_SUCCESS';
export const LOAD_SIMILARITY_SEARCH_RESULTS_FAILURE = 'findPreparations/similaritySearch/LOAD_SIMILARITY_SEARCH_RESULTS_FAILURE';
